import { ChevronRight, House, ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { BizcoverIndiaFigmaHeader } from "../../components/marketing/BizcoverIndiaFigmaHeader";
import { BizcoverIndiaFigmaFooter } from "../../components/marketing/BizcoverIndiaFigmaFooter";

export default function BizcoverIndiaNotFoundPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const fontsId = "bizcoverindia-figma-notfound-fonts";
    if (document.getElementById(fontsId)) return;

    const link = document.createElement("link");
    link.id = fontsId;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,600&family=Urbanist:wght@700&display=swap";
    document.head.appendChild(link);
  }, []);

  return (
    <div className="min-h-screen bg-[#fffef6]">
      <BizcoverIndiaFigmaHeader
        searchQuery={q}
        onSearchChange={setQ}
        onSearchSubmit={() => {
          const trimmed = q.trim();
          if (trimmed) navigate(`/search?q=${encodeURIComponent(trimmed)}`);
          else navigate("/search");
        }}
        onExploreCategoriesClick={() => navigate("/categories")}
      />

      <main className="mx-auto w-full max-w-[1920px] px-6 py-8 sm:px-10 lg:px-36">
        <nav className="mb-10 flex items-center gap-2 text-[13px] text-[#919eab]">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-1 text-[#637381] hover:text-[#212529]"
          >
            <House className="h-3.5 w-3.5" />
            Home
          </button>
          <ChevronRight className="h-3.5 w-3.5 text-[#b7c0ca]" />
          <span>404</span>
        </nav>

        <section className="mx-auto flex max-w-[564px] flex-col items-center text-center">
          <div className="relative mb-10 h-[360px] w-full">
            <div className="absolute left-1/2 top-8 h-[18px] w-[270px] -translate-x-1/2 rounded-full bg-[#eaf7f2]" />
            <div className="absolute left-1/2 top-16 -translate-x-1/2 text-[140px] font-bold leading-none text-[#088178] [font-family:'Urbanist',sans-serif]">
              404
            </div>
            <div className="absolute left-1/2 top-[145px] -translate-x-1/2 rounded-full bg-[#088178] p-8 shadow-[0px_12px_30px_rgba(8,129,120,0.25)]">
              <ShoppingCart className="h-24 w-24 text-white" strokeWidth={1.8} />
            </div>
          </div>

          <h1 className="text-[52px] font-bold leading-[64px] text-[#212529] [font-family:'Urbanist',sans-serif]">
            Oops!
          </h1>
          <p className="mt-3 max-w-[392px] text-[16px] leading-6 text-[#495057] [font-family:'DM Sans',sans-serif]">
            Sorry, we couldn&apos;t find that page. Try going back or checking out our homepage.
          </p>
          <button
            type="button"
            onClick={() => navigate("/")}
            className="mt-6 rounded-[24px] bg-[#088178] px-6 py-3 text-[14px] font-semibold leading-6 text-white shadow-[0px_6px_15px_0px_rgba(8,129,120,0.16)] transition hover:bg-[#056d6e]"
          >
            Back To Home
          </button>
        </section>
      </main>

      <BizcoverIndiaFigmaFooter
        email={email}
        onEmailChange={setEmail}
        onSubscribe={() => {
          // Preview-safe behavior; keeps page side effects isolated.
        }}
      />
    </div>
  );
}
